module.exports = __webpack_public_path__ + "media/question3_en.dc6d17be.mp3";